import { useState } from "react";
import { faqList } from "@/mocks/manga";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 text-xs font-label text-secondary-700 uppercase tracking-widest">
              <i className="ri-question-line text-base" aria-hidden="true"></i>
              FAQ
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              关于榜单怎么算、新番和榜单有什么区别、筛选会不会跳页，
              这里一次说清楚。还有疑问的话，也可以对照上面的更新日历自行核对。
            </p>
          </div>

          <div className="lg:col-span-8 flex flex-col gap-3">
            {faqList.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className="rounded-lg bg-background-100/70 border border-background-200 overflow-hidden"
                >
                  <h3>
                    <button
                      type="button"
                      aria-expanded={isOpen}
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                        {item.q}
                      </span>
                      <i
                        className={`shrink-0 text-xl text-primary-600 transition-transform ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                  </h3>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed animate-fade-up">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}